<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.phone"
        placeholder="手机号"
        style="width: 180px"
        class="filter-item"
        clearable
      />

      <el-input
        v-model="listQuery.user_id"
        placeholder="用户ID"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.product_no"
        placeholder="藏品编号"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <!-- <el-input
        v-model="listQuery.chain_address"
        placeholder="区块链地址"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.token_id"
        placeholder="NFTID"
        style="width: 180px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.tx_hash"
        placeholder="NFT哈希"
        style="width: 180px"
        class="filter-item"
        clearable
      /> -->
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="空投中" :value="1" />
        <el-option label="空投成功" :value="2" />
        <el-option label="空投失败" :value="3" />
      </el-select>
      <!-- <el-select
        v-model="listQuery.source_type"
        placeholder="来源类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="发行" :value="1" />
        <el-option label="购买" :value="2" />
        <el-option label="赠送" :value="3" />
        <el-option label="总后台赠送" :value="4" />
        <el-option label="盲盒开启" :value="5" />
        <el-option label="合成获得" :value="6" />
      </el-select>
      <el-select
        v-model="listQuery.lock_type"
        placeholder="锁定类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="未锁定" :value="0" />
        <el-option label="用户购买" :value="1" />
        <el-option label="用户赠送" :value="2" />
        <el-option label="总后台" :value="3" />
        <el-option label="空投锁定" :value="4" />
        <el-option label="盲盒锁定" :value="5" />
        <el-option label="合成锁定" :value="6" />
      </el-select>
      <el-select
        v-model="listQuery.product_category"
        placeholder="类别"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="普通NFT" :value="1" />
        <el-option label="盲盒NFT" :value="2" />
        <el-option label="合成NFT" :value="3" />
      </el-select> -->
      <el-date-picker
        class="filter-item"
        v-model="dateArr"
        type="datetimerange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd HH:mm:ss"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      ></el-date-picker>
      <!-- <el-select
        v-model="listQuery.pay_status"
        placeholder="支付状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="待支付" :value="1" />
        <el-option label="支付成功" :value="2" />
        <el-option label="订单取消" :value="4" />
      </el-select> -->
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >

        <el-button class="filter-item" type="primary" @click="downloadExcel">
          下载空投模板
        </el-button>
      <el-upload
        class="filter-item"
        accept=".xlsx,.xls"
        action=""
        :show-file-list="false"
        :auto-upload="false"
        :on-change="handleImportOrders"
      >
        <el-button type="warning" icon="el-icon-upload"> 导入空投 </el-button>
      </el-upload>
      <!-- <el-button class="filter-item" type="warning" @click="$router.go(-1)"
        >返回</el-button
      > -->
    </div>
    <div class="filter-container">
      <!-- <el-radio-group v-model="listQuery.status" size="small" @change="handleFilter">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button label="1">未匹配</el-radio-button>
        <el-radio-button label="2">待买家打款</el-radio-button>
        <el-radio-button label="3">已完成</el-radio-button>
        <el-radio-button label="4">已取消</el-radio-button>
      </el-radio-group> -->
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user ? scope.row.user.nickname : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="商品编号" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.product_no }}
        </template>
      </el-table-column>
      <el-table-column label="空投的产品id" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_product_id }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="头像" min-width="60" align="center">
        <template slot-scope="scope">
          <img
            :src="scope.row.user ? scope.row.user.avatar : '#'"
            class="user-avatar"
          />
        </template>
      </el-table-column> -->

      <!-- <el-table-column label="区块链地址" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user ? scope.row.user.chain_address : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="NFT名称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ JSON.parse(scope.row.product_snap).name }}
        </template>
      </el-table-column>
      <el-table-column label="NFT资源链接" min-width="80" align="center">
        <template slot-scope="scope">
          {{ JSON.parse(scope.row.product_snap).resources_url }}
        </template>
      </el-table-column>
      <el-table-column label="NFTID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.token_id }}
        </template>
      </el-table-column> -->
      <el-table-column label="状态" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="warning">空投中</el-tag>
          <el-tag v-else-if="scope.row.status === 2" type="success"
            >空投成功</el-tag
          >
          <el-tag v-else-if="scope.row.status === 3" type="danger"
            >空投失败</el-tag
          >
        </template>
      </el-table-column>
      <!-- <el-table-column label="产品哈希值" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.tx_hash }}
        </template>
      </el-table-column>
      <el-table-column label="来源类型" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.source_type === 1" type="primary"
            >发行</el-tag
          >
          <el-tag v-else-if="scope.row.source_type === 2" type="success"
            >购买</el-tag
          >
          <el-tag v-else-if="scope.row.source_type === 3" type="warning"
            >赠送</el-tag
          >
          <el-tag v-else-if="scope.row.source_type === 4" type="warning"
            >总后台赠送</el-tag
          >
          <el-tag v-else-if="scope.row.source_type === 5" type="success"
            >盲盒开启</el-tag
          >
          <el-tag v-else-if="scope.row.source_type === 6" type="success"
            >合成获得</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="锁定类型" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.lock_type === 0" type="primary"
            >未锁定</el-tag
          >
          <el-tag v-else-if="scope.row.lock_type === 1" type="success"
            >用户购买</el-tag
          >
          <el-tag v-else-if="scope.row.lock_type === 2" type="warning"
            >用户赠送</el-tag
          >
          <el-tag v-else-if="scope.row.lock_type === 3" type="warning"
            >总后台</el-tag
          >
          <el-tag v-else-if="scope.row.lock_type === 4" type="success"
            >空投锁定</el-tag
          >
          <el-tag v-else-if="scope.row.lock_type === 5" type="success"
            >盲盒锁定</el-tag
          >
          <el-tag v-else-if="scope.row.lock_type === 6" type="success"
            >合成锁定</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="产品类别" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.product_category === 1" type="primary"
            >普通NFT</el-tag
          >
          <el-tag v-else-if="scope.row.product_category === 2" type="success"
            >盲盒NFT</el-tag
          >
          <el-tag v-else-if="scope.row.product_category === 3" type="warning"
            >合成NFT</el-tag
          >
        </template>
      </el-table-column> -->
      <el-table-column label="创建时间" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <!-- <el-table-column
        class-name="status-col"
        label="支付状态"
        min-width="80"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.pay_status === 1" type="warning"
            >待支付</el-tag
          >
          <el-tag v-else-if="scope.row.pay_status === 2" type="success"
            >支付成功</el-tag
          >
          <el-tag v-else-if="scope.row.pay_status === 3" type="success"
            >支付失败</el-tag
          >
          <el-tag v-else-if="scope.row.pay_status === 4" type="danger"
            >订单取消</el-tag
          >
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="操作" align="center" width="240" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="show(scope.row)"
            v-if="scope.row.is_locking == 0"
            >转赠</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="del(scope.row.id)"
            v-if="scope.row.is_locking == 0"
            >销毁</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      title="赠送"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="220px">
        <el-form-item label="用户手机号/区块链地址" prop="to">
          <el-input v-model="form.to"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="导入数据预览"
      :visible.sync="importDataDialogVisible"
      center
      width="60%"
      :close-on-click-modal="false"
    >
      <div style="height: 500px" class="scrollbar">
        <el-scrollbar style="height: 500px">
          <el-table :data="yulanData" style="width: 1100px">
            <el-table-column label="序号" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.index || "" }}
              </template>
            </el-table-column>
            <el-table-column label="电话" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.phone || "" }}
              </template>
            </el-table-column>
            <el-table-column label="产品编号" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.product_no || "" }}
              </template>
            </el-table-column>
            <el-table-column label="空投数量" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.row.num || "" }}
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="importDataDialogVisible = false">取消</el-button>
        <el-button @click="importSaveData" type="primary" :loading="btnLoading"
          >确认导入</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import downloadExcel from "vue-json-excel";
import { excel2Json } from "@/utils/excel";
export default {
  data() {
    return {
      yulanData: [],
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        type: "",
        status: "",
        order_no: "",
        buyer_id: "",
        seller_id: "",
      },
      dialogFormVisible: false,
      importDataDialogVisible: false,
      btnLoading: false,
      rules: {
        to: [
          {
            required: true,
            message: "转赠的用户手机号/区块链地址不能为空",
            trigger: "change",
          },
        ],
      },
      form: {
        user_product_id: "",
        to: "",
      },
      dateArr: null,
    };
  },
  created() {
    if (this.$route.query.id != "undefined") {
      this.listQuery.product_id = this.$route.query.id;
    }
    this.getList();
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0];
        this.listQuery.end_at = newVal[1];
      } else {
        this.listQuery.start_at = "";
        this.listQuery.end_at = "";
      }
    },
  },
  methods: {

downloadExcel() {
  let a = document.createElement("a");
  a.href = "/空投模板.xlsx";
  a.download = "空投模板.xlsx";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
},
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/product/airdropLog",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleImportOrders(file) {
      console.log(1111);
      this.yulanData = [];
      file = file.raw;
      if (
        !(file.name.split(".")[1] == "xlsx" || file.name.split(".")[1] == "xls")
      ) {
        this.$message.error("上传文件格式不正确，请检查选择的文件");
        return;
      }
      excel2Json(file, 1).then((excelData) => {
        console.log(excelData);
        // 处理业务
        if (excelData.length <= 0) {
          this.$message.error("数据不能为空");
          return;
        }
        excelData.forEach((element, index) => {
          if (element["电话"]) {
            this.yulanData.push({
              index: element["序号"],
              phone: element["电话"],
              product_no: element["产品编号"] || "",
              num: element["空投数量"] || "",
            });
          }
          console.log(element, "--------", index);
        });
        this.importDataDialogVisible = true;
        console.log(this.yulanData, "=============");
      });
    },
    importSaveData() {
      this.btnLoading = true;
      for (let index = 0; index < this.yulanData.length; index++) {
        const item = this.yulanData[index];
        for (var key in item) {
          if (!item[key]) {
            this.$message({
              type: "error",
              message: "请完善数据!!",
            });
            this.btnLoading = false;
            return;
          }
        }
      }
      request({
        url: "/api/backend/product/airdrop",
        method: "post",
        data: {
          airdrops: this.yulanData,
        },
      })
        .then((response) => {
          this.btnLoading = false;
          this.importDataDialogVisible = false;
          this.getList();
          this.$notify({
            type: "success",
            message: "操作成功!成功数量："+response.data.success_num+",失败数量："+response.data.fail_num+",失败的手机号："+JSON.stringify(response.data.not_existent) ,
            showClose:true,
            duration:15*1000
          });
        })
        .catch((err) => {
          this.btnLoading = false;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleEdit(object) {
      this.form = JSON.parse(JSON.stringify(object));
      this.dialogFormVisible = true;
    },
    show(row) {
      this.dialogStatus = "赠送";
      this.dialogFormVisible = true;
      this.form.user_product_id = row.id;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      if (!this.form.link_type) {
        this.form.link = "";
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/product/passOn",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    //上下架
    del(val) {
      this.$confirm("此操作将删除该nft, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/product/burn",
            method: "post",
            data: { user_product_id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
